import blue from './blue/params'
import green from './green/params'
import iceblue from './iceblue/params'
import porcelain from './porcelain/params'
import purple from './purple/params'

export const themes = {
    [blue.name]: blue,
    [green.name]: green,
    [iceblue.name]: iceblue,
    [porcelain.name]: porcelain,
    [purple.name]: purple
}
